import React from "react";
import {Map} from 'immutable';

export const SystemVariablesContext = React.createContext(Map({}));